import { faAngleDown } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cs from 'classnames';
import React from 'react';
import { Popover } from 'react-tiny-popover';
import styles from './PopoverButton.module.scss';


interface Props {
  children: React.ReactNode;
  buttonText: React.ReactNode;
  className?: string;
  caret?: boolean;
}



export const PopoverButton = (props: Props) => {
  const [isOpen, setIsOpen] = React.useState(false);
  return (
    <Popover 
      isOpen={isOpen} 
      // Default to showing below if possible
      positions={['bottom', 'right', 'top', 'left']}
      // Align to the left of the button
      align="start"
      padding={8}
      reposition={true}
      containerStyle={{zIndex: "10"}}
      boundaryInset={15}
      onClickOutside={() => setIsOpen(false)}
      content={() => (
        <div className={cs(styles.PopoverButtonPopover, 'border bg-white shadow')}>
          <button className="btn btn-link float-right rounded-0" onClick={() => setIsOpen(!isOpen)} type="button">
            &times;
          </button>
          <div className="p-3">
            {props.children}
          </div>
        </div>
      )}
    >
      <button 
        className={props.className || "btn btn-link px-0 py-0"} 
        onClick={e => {
          e.preventDefault();
          setIsOpen(!isOpen); 
        }}
        type="button"
      >
        {props.buttonText} {props.caret && (<FontAwesomeIcon icon={faAngleDown} size={"lg"} />)}
      </button>
    </Popover>
  )
}
